export default __webpack_public_path__ + "assets/ico_invites-94973203.svg";